<div class="inspection-dialog" *ngIf="data.dataResponse else newComment">
    <h2 mat-dialog-title>Comment Details</h2>

    <mat-dialog-content class="dialog-content">
        <div class="info-grid">
            <div class="info-item">
                <span class="label">Comment ID</span>
                <span class="value">{{ data.dataResponse.id }}</span>
            </div>

            <div class="info-item">
                <span class="label">Comment Date</span>
                <span class="value">{{ data.dataResponse.commentDate | date:'short' }}</span>
            </div>

            <div class="info-item">
                <span class="label">By</span>
                <span class="value">{{ data.dataResponse.createdBy.name }}</span>
            </div>
        </div>

        <!-- <mat-divider></mat-divider> -->

        <mat-form-field appearance="outline" class="full-width comment-field">
            <mat-label>Comment</mat-label>
            <textarea matInput [formControl]="miCampo" rows="4" 
                maxlength="500">
            </textarea>

            <mat-hint align="end">
                {{ miCampo.value?.length || 0 }}/500
            </mat-hint>
            <mat-error *ngIf="miCampo.hasError('required')">
                Comment is required
            </mat-error>

            <mat-error *ngIf="miCampo.hasError('minlength')">
                Minimum 5 characters required
            </mat-error>

            <mat-error *ngIf="miCampo.hasError('maxlength')">
                Maximum 500 characters allowed
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-stroked-button color="warn" type="button" (click)="deleteComment()">
            DELETE
        </button>

        <button mat-flat-button color="primary" type="button" (click)="updateComment()" [disabled]="miCampo.invalid">
            UPDATE
        </button>

        <button mat-button type="button" (click)="cerrarDialogo()">
            CANCEL
        </button>
    </mat-dialog-actions>
</div>


<ng-template class="inspection-dialog" #newComment>
    <h2 mat-dialog-title>Add Comment</h2>

    <mat-dialog-content class="dialog-content">

        <mat-form-field appearance="outline" class="full-width comment-field">
            <mat-label>Comment</mat-label>
            <textarea matInput [formControl]="miCampo" rows="4"
                maxlength="500">
            </textarea>

            <mat-hint align="end">
                {{ miCampo.value?.length || 0 }}/500
            </mat-hint>

            <mat-error *ngIf="miCampo.hasError('required')">
                Comment is required
            </mat-error>

            <mat-error *ngIf="miCampo.hasError('minlength')">
                Minimum 5 characters required
            </mat-error>

            <mat-error *ngIf="miCampo.hasError('maxlength')">
                Maximum 500 characters allowed
            </mat-error>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-flat-button color="primary" type="button" (click)="createComment()" [disabled]="miCampo.invalid">
            SAVE
        </button>

        <button mat-flat-button type="button" (click)="cerrarDialogo()">
            CANCEL
        </button>
    </mat-dialog-actions>
</ng-template>